import * as React from 'react';
import { StatistikAside } from './StatistikAside';
import { Store } from '../store/Store';
import { BasicPortalStructure } from '../layout/BasicPortalStructure';
import { StoreContext } from '../utils';

export interface Props {
  store: Store;
}

export class StatistikPortal_ extends React.Component<Props, {}> {
  get topbarRight() {
    return null;
  }

  get topbarLeft() {
    return <div className="kt-header__brand-nav">Statistik-Bereich</div>;
  }

  render() {
    const { children, store } = this.props;
    return (
      <StoreContext.Provider value={store}>
        <BasicPortalStructure aside={<StatistikAside />} content={children} />
      </StoreContext.Provider>
    );
  }
}
